import Vue from 'vue'
import App from './App.vue'
import { Button, Select, Carousel, CarouselItem, Tabs, TabPane, Row, Col, Table, TableColumn } from 'element-ui';
Vue.use(Button).use(Select).use(Carousel).use(CarouselItem).use(Tabs).use(TabPane).use(Row).use(Col).use(Table).use(TableColumn);
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
Vue.use(VueRouter)
Vue.config.productionTip = false
import router from './router'
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next() // 确保一定要调用 next()
})
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')